import React from 'react';
import ModuleRoute from 'holocron-module-route';

const childRoutes = () => [
  <ModuleRoute moduleName="axp-page-wrapper" containerClassName="form-wrapper" key="wrapper">
    <ModuleRoute exact={true} path="/iForms/:pageType/:cuid" moduleName="axp-iform-renderer" />
    {/* // child route for auth_reg */}
    <ModuleRoute exact={true} path="/iFormsSecure/auth_reg/:langCountry/iforms.do" moduleName="axp-iform-renderer" />
    {/* // child route for auth_reg with formParam (for myob form) */}
    <ModuleRoute exact={true} path="/iFormsSecure/auth_reg/:formParam/:langCountry/iforms.do" moduleName="axp-iform-renderer" />
    {/* // child route for unsecure forms */}
    <ModuleRoute exact={true} path="/iFormsSecure/un/iforms.do" moduleName="axp-iform-renderer" />
  </ModuleRoute>,
];

export default childRoutes;
